import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFileMedical,
  FaNotesMedical,
  FaHospital,
  FaSimplybuilt,
  FaBuilding,
  FaIdBadge,
  FaClinicMedical,
} from 'react-icons/fa';
import { ISigla, readSigla } from './siglas';
import { MdError, MdDateRange, MdChat } from 'react-icons/md';
import instituicoes from './instituicoes';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../components/Forms/Input';
import Button from '../../../components/Forms/Button';
import Loader from '../../../components/Loader';
import MaskedInput from '../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../components/ResponseMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../../../components/Forms/SelectSimple';
import Whatsapp from '../../../components/WhatsAppCompartilhar';

import api from '../../../services/api';
import { authTitle, recaptchaKey, urlWebsite } from '../../../config';
import { countries } from './countries';
import TextareaInput from '../../../components/Forms/TextareaInput';
import { useToast } from '../../../hooks/Toast';
import CheckboxInput from '../../../components/Forms/CheckboxInput';
import getCep from '../../../services/cep';
import { useLanguage } from '../../../hooks/Language';

interface IRecoverFormData {
  [key : string] : any;
}


interface IRead {
  [key: string]: any;
}


interface ICaptcha {
  getValue(): string;
}

const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
const siglas = readSigla();
  const {addToast} = useToast();

  const [countryISO, setCountryISO] = useState('BR');
const { translate} = useLanguage();
  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
      formRef?.current?.setFieldValue('state', cepResponse.uf);
    }
  };


  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Nome obrigatório'),
        email: Yup.string()
          .required('Email obrigatório')
          .email('Preencha um email válido'),
          document_number: Yup.string().required('CPF é obrigatório'),
        
        company: Yup.string().required('Instituição é obrigatório'),
        position: Yup.string().required('Informe se tem vinculo com o HCPA'),

        term: Yup.string().required('Informe se você autoriza o receber divulgações.'),
      });



      await schema.validate(data, { abortEarly: false });

  

      const captchaValue =
      getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
      false;

      const newUser = await api
        .post('/signup', {
          ...data,
          captcha : captchaValue,
        
        })
        .catch(error => {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formRef.current?.setErrors(errors);
            setLoading(false);
          }

          addToast({
            type: 'error',
            title: error.response.data.message,
          });
          setLoading(false);
          return false;
        });

      if (!newUser) {
        setLoading(false);
        return false;
      }

      setSuccess(true);
      setLoading(false);
     

      return false;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        const errorInfo = err.errors.reduce((error, prev) => {
          prev = `${prev}, ${error}`;
          return prev;
        });
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Erro de validação',
          description: errorInfo,
        });
      }
      setLoading(false);
    }
  }

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside style={{background:'rgba(0,0,0,0.5)', padding: '20px', borderRadius:'10px'}}>
        {success ? (
          <ResponseMessage
            active
            type="clean"
            title=""
            description={
              <p style={{color: '#333', width: '100%', textAlign: 'center'}}>
                <h2 className="titleH2" style={{color: '#333', width: '100%', textAlign: 'center'}}> Cadastro realizado com sucesso!</h2>
                <br />
                <aside style={{width:'100%', display: 'flex', justifyContent:'center'}}>
                <Link to="login" style={{width:'100%', display: 'flex', justifyContent:'center'}}>
                  <button className="defaultButton" type="button">
                    Acessar
                  </button>
                </Link>
                </aside>
                <br />
                Aproveite e indique para seus amigos!
                <Whatsapp
                  text={`Olá! Acabei de me inscrever no ${authTitle} . Acredito que você irá gostar de participar desse evento! Inscreva-se pelo link: ${urlWebsite}`}
                  number=""
                  message="Compartilhe!"
                />
              </p>
            }
          />
        ) : (<>
           
                  <Form ref={formRef} onSubmit={handleNewLogin} initialData={{country: 'BR'}}>
                    <h1 style={{color: '#fff'}}>Novo cadastro</h1>

                    <Input name="name" placeholder="Nome completo" />
                    <Input name="email" placeholder="E-mail" />
                    <MaskedInput
                      mask="999.999.999-99"
                      name="document_number"
                      placeholder="CPF"
                    />
                     <SelectSimple
                      options={instituicoes}
                      name="company"
                      formRef={formRef}
                      label="Instituição"
                    />






                    <SelectSimple
                      options={[
                        {  label: 'Professor', value: 'Professor'},
                        { label: 'Contratado', value: 'Contratado'},
                        {  label: 'Residente', value: 'Residente'},
                        {  label: 'Aluno de graduação', value: 'Aluno de graduação'},
                        {  label: 'Aluno de pós-graduação', value: 'Aluno de pós-graduação'},
                        {  label: 'Nenhum', value: 'Nenhum'},

                      ]}
                      name="position"
                      formRef={formRef}
                      label="Vinculo com o HCPA"
                    />

             

<CheckboxInput
              style={{ display: 'flex'  }}
              name="term"
              unique={true}
              preText={(
                <>
                  {' '}
                  As informações necessárias para emissão de certificados (nome e e-mail) serão arquivadas pelo HCPA e os demais dados deletados após o evento.<br/><br/>
                  Estou ciente de que estou fornecendo à {authTitle} e seus parceiros meus
                  contatos gerais, os quais são dados pessoais protegidos pela
                  Lei Geral de Proteção de Dados brasileira, para gestão de
                  relacionamento e marketing da empresa, conforme Política de Privacidade disponível neste site.
{' '}
                 
                </>
              )}
              options={[
                {
                  id: `Aceito receber divulgações dos eventos do HCPA.`,
                  label: 'Aceito receber divulgações dos eventos do HCPA.',
                  value: `Aceito receber divulgações dos eventos do HCPA.`,
                },
                {
                  id: `Não aceito receber divulgações dos eventos do HCPA.`,
                  label: 'Não aceito receber divulgações dos eventos do HCPA.',
                  value: `Não aceito receber divulgações dos eventos do HCPA.`,
                },
              ]}
            />

<p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#fff',
                  fontSize: '12px',
                  textAlign: 'left',
                }}
              >
                {'Ao me cadastrar, afirmo que li a'}
{' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#fff' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    {'Política de Privacidade'}
{' '}
                  </Link>
{' '}
                </strong>
                {'desta plataforma.'}
              </p>

                    <aside style={{display: 'flex', width:'100%', justifyContent: 'center', alignItems: 'center'}}>
                    <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />

                    </aside>
                    <aside style={{display: 'flex',width:'100%', justifyContent: 'center', alignItems: 'center'}}>
                    <button className="defaultButton" type="submit">
                      Finalizar inscrição

                  
                    </button>
                    </aside>
                  </Form>
        </>
        )}
      </aside>
    </>
  );
};

export default FormContainer;
